module.exports = __webpack_public_path__ + "img/product-shuttle-2.c388db46.png";